import { UPDATE_FIELD, RESET_FORM } from './types';

const initialState = {
  forms: {
    primary: {
      fields: {
        name: {
          value: '',
          error: null
        },
        email: {
          value: '',
          error: null
        },
        subject: {
          value: '',
          error: null
        },
        message: {
          value: '',
          error: null
        }
      }
    },
    secondary: {
      fields: {
        name: {
          value: '',
          error: null
        },
        email: {
          value: '',
          error: null
        },
        linkedin: {
          value: '',
          error: null
        },
        message: {
          value: '',
          error: null
        },
        cv_pdf: {
          value: '',
          error: null
        }
      }
    }
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_FIELD: {
      const { error = null, value = '' } = action.payload;
      return {
        ...state,
        forms: {
          ...state.forms,
          [action.payload.form]: {
            ...state.forms[action.payload.form],
            fields: {
              ...state.forms[action.payload.form].fields,
              [action.payload.name]: {
                value,
                error
              }
            }
          }
        }
      };
    }
    case RESET_FORM:
      return initialState;
    default:
      return state;
  }
};

export { reducer as contactReducer };



// WEBPACK FOOTER //
// ./src/store/ContactForm/reducer.js